<script lang="ts">
    import KpResponsiveGenericTable from '../commons/ui-components/table/KpResponsiveGenericTable.svelte';
    import type {LocalizeFunction} from '../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY, pipe} from '../svelte/utils';
    import KpLoadingBlock from '../commons/components/kp-loading/KpLoadingBlock.svelte';
    import type {Injector} from '../svelte/types';
    import {KpDepartmentsPresenter} from './kp-departments.presenter';
    import {loc} from '../svelte/pipes';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpDepartmentsPresenter = injector.getByToken(KpDepartmentsPresenter.presenterName);
</script>

<h1>{localize(/* @kp-localization commons.Rentals */ 'commons.Rentals')}</h1>

<KpResponsiveGenericTable hoverRows={true}>
    <slot slot="header">
        <tr>
            <th>#</th>
            <th>
                {localize( /* @kp-localization commons.Poradi */ 'commons.Poradi')}
            </th>
            <th>
                {localize( /* @kp-localization commons.nazev */ 'commons.nazev')}
            </th>
            <th>Nadřazená</th>
            <th>Centrální</th>
            <th>Online</th>
            <th>Exemplářová</th>
            <th>Sigla</th>
            <th>{localize( /* @kp-localization commons.Locations */ 'commons.Locations')}</th>
        </tr>
    </slot>
    <slot slot="body">
        {#await presenter.getDepartments()}
            <KpLoadingBlock/>
        {:then departments}
            {#each departments as department (department.id)}
                <tr>
                    <td>{department.id}</td>
                    <td>{department.order}</td>
                    <td>
                        <span>{department.name}</span>
                        <br/>
                        <span class="text-muted">({department.text})</span>
                    </td>
                    <td>{department?.parent?.id ?? ''} - {pipe(department.parent, loc()) ?? ''}</td>
                    <td><span class:hidden={!department.central} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!department.online} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!department.exemplarable} class="glyphicon glyphicon-ok"></span></td>
                    <td>{department.sigla ?? ''}</td>
                    <td>
                        <ul>
                            {#each department.locations as location }
                                <li>{location.id ?? ''} - {pipe(location, loc()) ?? ''}</li>
                            {/each}
                        </ul>
                    </td>
                </tr>
            {/each}
        {/await}
    </slot>
</KpResponsiveGenericTable>